import { render, staticRenderFns } from "./CatchupTable.vue?vue&type=template&id=4b475200"
import script from "./CatchupTable.vue?vue&type=script&lang=js"
export * from "./CatchupTable.vue?vue&type=script&lang=js"
import style0 from "./CatchupTable.vue?vue&type=style&index=0&id=4b475200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports